import React, { Fragment, useEffect } from 'react';
import { LmsHeader } from './lmsheader';
import { Outlet, useParams } from 'react-router-dom';
import Sidebar from './lms/Sidebar';
import { useAppDispatch } from '../store/hook';
import { getLmsLists } from '../store/features/lmsSlice';
import ScrollToTop from './layout/ScrollToTop';
import Popup from './modal/Popup';
import { PopupCategory } from '../constants/types/popup-type';

const LmsLayout = () => {
  const dispatch = useAppDispatch();
  const queryParams = useParams();

  const classId = queryParams.id ? queryParams.id : queryParams.classId;

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(getLmsLists({ url: `/v1/class/${classId}` })).unwrap();
      } catch (error) {}
    };
    fetchData();
  }, [classId]);

  return (
    <Fragment>
      <Popup categoryId={PopupCategory.LMS} />
      <div className="fixed left-0 top-0 z-[10000] mx-auto w-full px-0">
        <LmsHeader classId={classId} />
      </div>
      <main className="mt-[140px] xl:mt-[60px] xl:w-full">
        <div className="flex bg-gray1">
          <div className="hidden h-[calc(100vh-60px)] overflow-y-auto overflow-x-hidden bg-gray2 xl:block xl:min-w-[210px]">
            {/* <div className="hidden overflow-y-auto overflow-x-hidden bg-gray2 xl:block xl:min-w-[210px]"> */}
            <Sidebar classId={classId} />
          </div>
          {/* <div className="flex bg-gray1"> */}
          {/* <div className="mx-auto flex w-full max-w-[1920px] bg-gray1"> */}
          <div className="mx-auto w-full max-w-[1920px] bg-gray1">
            <ScrollToTop>
              <Outlet />
            </ScrollToTop>
          </div>
        </div>
      </main>
    </Fragment>
  );
};

export default LmsLayout;
